import type { SVGProps } from 'react';
export const Measurement = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="m12.51 4.43-1.3 1.3 1.53 1.53a.68.68 0 1 1-.96.96l-1.53-1.53-1.3 1.3 1.53 1.53a.68.68 0 1 1-.96.96L8 8.95l-1.3 1.3 1.53 1.53a.68.68 0 0 1-.96.96l-1.53-1.53-1.3 1.3 3.06 3.06 8.08-8.08zm-.83-1.08c.46-.47 1.2-.47 1.67 0l3.3 3.3c.47.47.47 1.21 0 1.67l-8.33 8.33c-.46.47-1.2.47-1.67 0l-3.3-3.3a1.2 1.2 0 0 1 0-1.67z"
      clipRule="evenodd"
    />
  </svg>
);
